import React, { useState } from 'react';
import { Link, Head } from '@inertiajs/inertia-react';
import Timer from '@/Components/Timer';
import { DateTime } from 'luxon';
import { Inertia } from '@inertiajs/inertia';

export default function ErrorMessage({title = 'Lo sentimos', message, linkRoute, linkName = 'Ir', method = 'get', autoRedirect = false, autoRedirectTimeout = 10000, externalLink = false}) {
    
    const [secondsTimeout, setSecondsTimeout] = useState(autoRedirectTimeout / 1000);

    return (
        <>
            <Head title="Error - Cerogrado" />
            <div className="relative flex items-top justify-center min-h-screen bg-gray-100 sm:items-center sm:pt-0">

                <div className="max-w-6xl mx-2 sm:mx-auto sm:px-6 lg:px-8 py-4">

                    <div className="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg border-red-600 border-2">

                        <h1 className='mb-4 text-center text-gray-900 text-lg font-bold'>{title}</h1>
                        <p className='text-center'>{message}</p>

                        {autoRedirect && (
                            <div>
                                <p>
                                    Te redireccionaremos en <Timer
                                        deadline={DateTime.now().plus({ milliseconds: autoRedirectTimeout + 1000 }).toJSDate()}
                                        format="s"
                                        onFinish={() => {
                                            if (externalLink) {
                                                window.location.replace(linkRoute);
                                            } else {
                                                Inertia.visit(linkRoute);
                                            }
                                        }}
                                        onTick={(seconds) => setSecondsTimeout(seconds)}
                                    /> {secondsTimeout === 1 ? 'segundo' : 'segundos'}.
                                </p>
                            </div>
                        )}

                        {
                            linkRoute && (externalLink ? (
                                <a href={linkRoute} className="flex items-center px-4 py-2 bg-gray-900 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest active:bg-gray-900 transition ease-in-out duration-150 false justify-center mx-auto w-min mt-4">
                                    {linkName}
                                </a>
                            ) : (
                                <Link method={method} href={linkRoute} className='flex items-center px-4 py-2 bg-gray-900 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest active:bg-gray-900 transition ease-in-out duration-150 false justify-center mx-auto w-min mt-4'>
                                    {linkName}
                                </Link>
                            ))
                        }
                    </div>

                </div>
            </div>
        </>
    );
}
